module.exports = __webpack_public_path__ + "img/MyPCP-Enrollment-Slider-3.17120435.svg";